// #2121-spec-kits
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Button, Input, Spinner } from 'reactstrap';
import { translate } from 'react-translate';
import TablePracticeOrders from './TablePracticeOrders';
import Paginator from '../Common/Paginator';
import { actionGetOrdersList } from 'store/actions/practiceOrdersActions';
import { useHistory } from 'react-router-dom';

const PracticeOrdersList = (props) => {
  const { t } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, page, lastPage, limit, total } = useSelector((s) => s.practiceOrdersReducer.orders);

  const [_page, setPage]            = useState(0);
  const [_limit]                    = useState(20);
  const [totalPage, setTotalPage]   = useState(0);
  const [filter, setFilter]         = useState(null);
  const [loadingLocal, setLoading]  = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    dispatch(actionGetOrdersList(_page, _limit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      setLoading(false);
      setPage(page);
      setTotalPage(lastPage);
    }
  }, [data, page, lastPage]);

  // Search debounce
  useEffect(() => {
    const t = setTimeout(() => {
      const value = searchTerm && searchTerm.length > 2 ? searchTerm : null;
      if (value !== filter) {
        setFilter(value);
        setLoading(true);
        dispatch(actionGetOrdersList(0, _limit, value));
        setPage(0);
      }
    }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const onPageChange = (page) => {
    setLoading(true);
    dispatch(actionGetOrdersList(page, _limit, filter));
  };

  const createOrder = (e) => {
    e.preventDefault();
    history.push('/admin/practice-orders/form/');
  };

  return (
    <div className="content order-list-page mt-3">

      <div className="order-list-header">
        <h2 className="order-list-page-title">
          {t('list-title') || 'Practice orders and fulfillment.'}
        </h2>
        <Button color="primary" onClick={createOrder} className="order-list-add">
          <i className="now-ui-icons ui-1_simple-add" /> {t('add-new-order') || 'New order'}
        </Button>
      </div>

      <div className="order-list-search">
        <i className="now-ui-icons ui-1_zoom-bold order-list-search-icon" />
        <Input
          type="text"
          value={searchTerm}
          placeholder={t('search-rich-placeholder') || 'Search by practice or owner...'}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button
            type="button"
            className="order-list-search-clear"
            onClick={() => setSearchTerm('')}
            aria-label="Clear"
          >
            <i className="now-ui-icons ui-1_simple-remove" />
          </button>
        )}
        {searchTerm && searchTerm.length > 0 && searchTerm.length <= 2 && (
          <small className="order-list-search-hint">{t('search-hint') || 'Type at least 3 characters'}</small>
        )}
      </div>

      <Card className="order-list-card">
        <CardBody className="order-list-card-body">
          {loadingLocal ? (
            <div className="order-list-loading">
              <Spinner color="primary" />
            </div>
          ) : !data || data.length === 0 ? (
            <div className="order-list-empty">
              <i className="now-ui-icons shopping_delivery-fast" />
              <h5>{t('empty-title') || 'No orders to show'}</h5>
              <p>{filter ? (t('empty-search') || 'No matches for the current search.')
                         : (t('empty-default') || 'Create a new order to get started.')}</p>
            </div>
          ) : (
            <TablePracticeOrders data={data} loading={false} page={_page} callback={onPageChange} />
          )}

          {data && data.length > 0 && (
            <>
              <div className="order-list-total">
                {t('showing') || 'Showing'} {data.length}
                {typeof total === 'number' && <> {t('of') || 'of'} {total}</>}
              </div>
              <div className="d-flex justify-content-center align-items-center mt-3">
                <Paginator
                  totalPages={totalPage}
                  currentPage={_page}
                  pageSize={_limit}
                  filter={filter}
                  callback={onPageChange}
                />
              </div>
            </>
          )}
        </CardBody>
      </Card>

    </div>
  );
};

export default translate('practice-orders')(PracticeOrdersList);
